const loginEvent = new CustomEvent('userLoggedIn', {
  detail: {
    loggedIn: true,
  }
});

export default () => document.dispatchEvent(loginEvent);
